import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import useMountedRef from './useMountedRef';

export interface ReturnedData<T> {
  data?: T;
  error?: Error;
  loading?: boolean;
}

function useFetch<T>(uri: string): ReturnedData<T> {
  const [data, setData] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState<boolean>();
  const { getAccessTokenSilently } = useAuth0();

  const mounted = useMountedRef();

  useEffect(() => {
    const createFetch = async () => {
      const accessToken = await getAccessTokenSilently();
      if (!uri) return;
      if (!mounted.current) return;
      setLoading(true);
      fetch(uri, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then((res) => {
          if (!mounted.current) throw new Error('component is not mounted');
          return res;
        })
        .then((response) => response.json())
        .then(setData)
        .then(() => setLoading(false))
        .catch((err) => {
          if (!mounted.current) return;
          setError(err);
        });
    };
    createFetch();
  }, [uri, mounted, getAccessTokenSilently]);

  return {
    loading,
    data,
    error,
  };
}

export default useFetch;
